import { useMutation } from '@tanstack/react-query';
import { QUERY_KEYS, queryClient } from '@src/query';
import { ApiError } from '@src/services/api';
import { ApiTypes } from 'common';
import { updateCreator } from './api';

export const useMutationUpdateCreator = () =>
  useMutation<void, ApiError, { id: string, doc: ApiTypes.BodyUpdateCreator }>({
    mutationFn: (params) => updateCreator(params),
    onSuccess: async (res, partialInfluencer) => {
      let key = QUERY_KEYS.influencers();
      queryClient.invalidateQueries({ queryKey: key });
      queryClient.refetchQueries({ queryKey: key });

      key = QUERY_KEYS.blacklistedCreators();
      queryClient.invalidateQueries({ queryKey: key });
      queryClient.refetchQueries({ queryKey: key });
    },
  });
